export const MEMBERSHIP_SUBSCRIPTIONS_RESET_STATE = 'MEMBERSHIP_SUBSCRIPTIONS_RESET_STATE';
export const MEMBERSHIP_SUBSCRIPTIONS_CURRENT_ITEM = 'MEMBERSHIP_SUBSCRIPTIONS_CURRENT_ITEM';

export const MEMBERSHIP_SUBSCRIPTIONS_REQUEST_LOADING = 'MEMBERSHIP_SUBSCRIPTIONS_REQUEST_LOADING';
export const MEMBERSHIP_SUBSCRIPTIONS_REQUEST_SUCCESS = 'MEMBERSHIP_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const MEMBERSHIP_SUBSCRIPTIONS_REQUEST_FAILED = 'MEMBERSHIP_SUBSCRIPTIONS_REQUEST_FAILED';

export const MEMBERSHIP_SUBSCRIPTIONS_CURRENT_ACTION = 'MEMBERSHIP_SUBSCRIPTIONS_CURRENT_ACTION';
export const MEMBERSHIP_SUBSCRIPTIONS_RESET_ACTION = 'MEMBERSHIP_SUBSCRIPTIONS_RESET_ACTION';